import React, { useContext, useEffect, useState } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import EditReportIcon from "../../../../components/SVGComponents/EditReportIcon";
import GPTMicIcon from "../../../../components/SVGComponents/GPTMicIcon";
import { Toggle } from "@fluentui/react/lib/Toggle";
import { Pivot, PivotItem } from "@fluentui/react";
import { RefreshIcon } from "@fluentui/react-icons-mdl2";
import { SHOW_NOT_ORIGNAL_MODALITY_LIST } from "../../../../constants/Constants";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { ClassicEditor, Essentials, Paragraph, Bold, Italic } from 'ckeditor5';
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";

const CustomEditor = (props) => {
  const height =
    (SHOW_NOT_ORIGNAL_MODALITY_LIST.includes(props.modality)
      ? props.customHeight - 165
      : props.showPathologyOptions
      ? props.customHeight - 230
      : props.customHeight - 165
    ).toString() + "px";

  const [editReport, setEditReport] = useState(true);

  const {
    refreshReport,
    patientReports,
    activeTab,
    setActiveTab,
    disableAddendumTab,
    addendumModel,
    setAddendumModel,
  } = useContext(studyReportContext);


  useEffect(() => {
    setTimeout(() => {
      if (editReport) {
        let ele = document.getElementsByClassName("fr-toolbar");
        if (ele[0] != undefined) {
          if (ele[0].style != undefined) {
            // console.log(ele[0].style);
            ele[0].style.display = "";
          }
        }
      } else {
        let ele = document.getElementsByClassName("fr-toolbar");
        if (ele[0] != undefined) {
          if (ele[0].style != undefined) {
            // console.log(ele[0].style);
            ele[0].style.display = "none";
          }
        }
      }
    }, 500);
  }, [editReport]);

  const {
    model,
    setShowToast,
    handleModelChange,
    firstReportAdded,
    setFirstReportAdded,
  } = useContext(studyReportContext);

  useEffect(() => {
    if (firstReportAdded == true) {
      setTimeout(() => {
        setEditReport(true);
      }, 100);
    }
  }, [firstReportAdded]);

  useEffect(() => {
    if (patientReports.length == 0) {
      setFirstReportAdded(false);
      setEditReport(true);
    }
  }, [patientReports]);

  useEffect(() => {
    // console.log(activeTab);
    if (activeTab == 1) {
      let ele = document.getElementsByClassName("custom-tab");
      if (!ele[0].classList.contains("custom-tab-line"))
        ele[0].classList.add("custom-tab-line");
      if (ele[1].classList.contains("custom-tab-line"))
        ele[1].classList.remove("custom-tab-line");
    }
    if (activeTab == 2) {
      let ele = document.getElementsByClassName("custom-tab");
      if (!ele[1].classList.contains("custom-tab-line"))
        ele[1].classList.add("custom-tab-line");
      if (ele[0].classList.contains("custom-tab-line"))
        ele[0].classList.remove("custom-tab-line");
    }
    // let ele = document.getElementsByClassName("fr-toolbar");
    // if(ele[0] != undefined){
    //     if(ele[0].style != undefined){
    //         console.log(ele[0].style);
    //         ele[0].style.display = "";
    //     }
    // }
    // console.log(ele);
  }, [activeTab]);

  const editorConfig = {
    toolbar: [
      { name: "clipboard", items: ["Undo", "Redo"] },
      {
        name: "basicstyles",
        items: [
          "Bold",
          "Italic",
          "Underline",
          "RemoveFormat",
          "CopyFormatting",
        ],
      },
      {
        name: "styles",
        items: ["Format", "Font", "FontSize", "TextColor", "BGColor"],
      }, // Add 'TextColor' and 'BGColor' to the 'styles' group
      {
        name: "align",
        items: ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"],
      },
      {
        name: "paragraph",
        items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent"],
      },
      { name: "tools", items: ["Maximize", "Zoom", "Table"] },
      { name: "editing", items: ["Scayt"] },
    ],
    // Additional configurations
    removeButtons: "Print, Strike",
    removePlugins: "magicline, elementspath, exportpdf",
    extraPlugins:
      "font,justify,colorbutton,image2,table,tabletools,tableresize,tableselection",
    removeDialogTabs: "image:advanced;link:advanced",
    //uiColor: '#7f8586',
    extraAllowedContent: "table tbody tr td th[*]{*}(*)",
    height: height,
    scayt_autoStartup: true,
    disableNativeSpellChecker: false,
    resize_enabled: false,
    fontSize_sizes:
      "8pt/10.67px;9pt/12px;10pt/13.33px;11pt/14.67px;12pt/16px;14pt/18.67px;16pt/21.33px;18pt/24px;20pt/26.67px;22pt/29.33px;24pt/32px;26pt/34.67px;28pt/37.33px;36pt/48px;48pt/64px;72pt/96px",
    font_defaultLabel: "Times New Roman",
    fontSize_defaultLabel: "12pt",
    language: "en",
    entities_latin: false,
    //enterMode: CKEDITOR.ENTER_P,
    fillEmptyBlocks: false,
    ignoreEmptyParagraph: true,
    pasteFromWordRemoveFontStyles: false,
    pasteFromWordRemoveStyles: false,
  };

  return (
    <div className="new-editor-section">
      <div className="tab-add-refresh-section">
        <div className="edit-report-icon">
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setEditReport((prev) => !prev);
            }}
          >
            <EditReportIcon active={editReport} />
           
          </span>

          <div style={{ marginLeft: "10px", cursor: "not-allowed" }}>
            {/* <GPTMicIcon/> */}
          </div>
        </div>
        <div className="custom-tab-section">
          <button
            className="custom-tab "
            onClick={() => {
              setEditReport(true);
              setActiveTab(1);
            }}
          >
            <span className="custom-tab-text">Final Report</span>
          </button>
          <button
            style={{ cursor: disableAddendumTab ? "not-allowed" : "pointer" }}
            className="custom-tab"
            onClick={() => {
              setEditReport(true);
              setActiveTab(2);
            }}
            disabled={disableAddendumTab}
          >
            <span className="custom-tab-text">Addendum</span>
          </button>
        </div>
        <div onClick={refreshReport} className="refresh-section">
          <CustomToolTipHost content="Refresh" id="ckeditor-refresh-tooltip">
            <div className="refresh-button">
              <RefreshIcon />
              <span className="refresh-text">Refresh</span>
            </div>
          </CustomToolTipHost>
        </div>
      </div>
      {(activeTab == 1 || activeTab == 2) && patientReports.length > 0 && (
        <div
          className="modal-scroll-annotation"
          style={{ height: height, overflow: "auto" }}
        >
          {activeTab == 1 ?  
            //<CKEditor    
            //key={model.length > 0 ? model : 1}        
            //config={editorConfig}
            //initData={model}
            //data={model}
            //onChange={(event)=>{console.log(event.editor.getData());handleModelChange(event.editor.getData(),false)}}
           ///>
           // Temporary CKEditor 5 implementation
           <CKEditor
              editor={ ClassicEditor }
              config={ {
                licenseKey: '<YOUR_LICENSE_KEY>', 
                plugins: [ Essentials, Paragraph, Bold, Italic ],
                toolbar: [ 'undo', 'redo', '|', 'bold', 'italic' ],
                initialData: model,
              } }
		        />
          :
          // <CKEditor    
          //   key={addendumModel.length > 0 ? addendumModel : 2}        
          //   config={editorConfig}
          //   initData={addendumModel}
          //   data={addendumModel}
          //   onChange={(event)=>{console.log(event.editor.getData());handleModelChange(event.editor.getData(),true)}}
          //  />
          <></>
          }
          
        </div>
        
      )}
      {/* {activeTab == 1 && patientReports.length == 0 && (
        <div
          className="modal-scroll-annotation"
          style={{ height: height, overflow: "auto" }}
        >
          <CKEditor    
            key="empty"   
            config={editorConfig}
           />
        </div>
      )}*/}
       {/* {activeTab == 2 && <div className="modal-scroll-annotation" style={{height:height,overflow:'auto'}}>

          <CKEditor    
            key={addendumModel.length > 0 ? addendumModel : 2}        
            config={editorConfig}
            initData={addendumModel}
            data={addendumModel}
            onChange={(event)=>{console.log(event.editor.getData());handleModelChange(event.editor.getData(),true)}}
           />
              
              </div>}  */}
    </div>
  );
};

export default CustomEditor;
